/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.30/esri/copyright.txt for details.
*/
import r from"../../../../core/Logger.js";const e=()=>r.getLogger("esri.views.3d.support.buffer.math");export{e as getMathLogger};
